var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTraksi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 157,
    viewBox: "0 0 171 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.812 97H103.625C98.6406 97 94.5625 92.95 94.5625 88C94.5625 83.05 98.6406 79 103.625 79H130.812C130.812 79 158 48.9062 158 34C158 19.0938 145.822 7 130.812 7C115.803 7 103.625 19.0938 103.625 34C103.625 41.1719 109.912 51.8313 116.454 61H103.625C88.6436 61 76.4375 73.1219 76.4375 88C76.4375 102.878 88.6436 115 103.625 115H130.812C135.797 115 139.875 119.05 139.875 124C139.875 128.95 135.797 133 130.812 133H65.5342C61.0029 139.975 55.9619 146.416 52.1387 151H130.812C145.794 151 158 138.878 158 124C158 109.122 145.794 97 130.812 97ZM130.812 25C135.825 25 139.875 29.0219 139.875 34C139.875 38.9781 135.825 43 130.812 43C125.8 43 121.75 38.9781 121.75 34C121.75 29.0219 125.8 25 130.812 25ZM40.1875 79C25.1777 79 13 91.0938 13 106C13 120.906 40.1875 151 40.1875 151C40.1875 151 67.375 120.906 67.375 106C67.375 91.0938 55.1973 79 40.1875 79ZM40.1875 115C35.1748 115 31.125 110.978 31.125 106C31.125 101.022 35.1748 97 40.1875 97C45.2002 97 49.25 101.022 49.25 106C49.25 110.978 45.2002 115 40.1875 115Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraksi);
export default __webpack_public_path__ + "static/media/traksi.fadd1e3f378cecdb7374932b33a9e579.svg";
export { ForwardRef as ReactComponent };